const SIM_ID = 'id';
const STUD_ID = 'sid';
const CHOOSE_SIM_STORAGE_KEY = 'simulationObject';
const REPORT_SIM_STORAGE_KEY = 'reportSim';
const REDIRECT_BACK_KEY = 'redirectBackTo';

export const setChooseSimulation = (obj, key) => {
	const objForStorage = {
		simulationId: obj[SIM_ID],
		studentId: obj[STUD_ID]
	};

	sessionStorage.setItem(
		key || CHOOSE_SIM_STORAGE_KEY,
		JSON.stringify(objForStorage)
	);
};

export const getChooseSimulation = key => {
	const storageObj =
		JSON.parse(sessionStorage.getItem(key || CHOOSE_SIM_STORAGE_KEY)) || {};

	return {
		id: parseInt(storageObj.simulationId),
		sid: parseInt(storageObj.studentId)
	};
};

export const swapChooseSimulation = () => {
	let sim = null;

	if (sessionStorage.getItem(CHOOSE_SIM_STORAGE_KEY)) {
		sim = getChooseSimulation();

		sessionStorage.removeItem(CHOOSE_SIM_STORAGE_KEY);

		setChooseSimulation(sim, 'preselectedSim');
	} else if (sessionStorage.getItem('preselectedSim')) {
		sim = getChooseSimulation('preselectedSim');

		sessionStorage.removeItem('preselectedSim');

		setChooseSimulation(sim);
	}
};

export const setStorageReportSim = sim => {
	const obj = {
		id: sim[SIM_ID],
		sid: sim[STUD_ID]
	};

	sessionStorage.setItem(REPORT_SIM_STORAGE_KEY, JSON.stringify(obj));
};

export const getStorageReportSim = () => {
	return JSON.parse(sessionStorage.getItem(REPORT_SIM_STORAGE_KEY)) || null;
};

export const removeStorageReportSim = () => {
	sessionStorage.removeItem(REPORT_SIM_STORAGE_KEY);
};

/**
 *
 * Set value to storage by given key.
 * if value is not presented the function won't do anything
 *
 * Unified by JSON.Stringify
 *
 * @param String key
 * @param any value
 */
export const setStorageData = (key, value) => {
	if (!value) {
		return;
	}
	sessionStorage.setItem(key, JSON.stringify(value));
};

/**
 *
 * Get item from storage by given key.
 * Unified by JSON.prase.
 *
 * If isPop si presented, the key will be deleted
 *
 * @param String key
 * @param Boolean isPop
 */
export const getStorageData = (key, isPop) => {
	const storageData = JSON.parse(sessionStorage.getItem(key));
	if (isPop) {
		sessionStorage.removeItem(key);
	}
	return storageData;
};

export const removeStorageData = (key, shouldReturn) => {
	if (shouldReturn) {
		return getStorageData(key, true);
	}

	sessionStorage.removeItem(key);
};

export const setStorageRedirectTo = routeName => {
	const disallowedRouteNames = ['category', 'simReport', 'chooseSimulation'];

	if (
		!disallowedRouteNames.includes(routeName) ||
		!getStorageData(REDIRECT_BACK_KEY)
	) {
		setStorageData(REDIRECT_BACK_KEY, routeName);
	}
};

export const removeStorageRedirectTo = shouldReturn => {
	return removeStorageData(REDIRECT_BACK_KEY, shouldReturn);
};

// TODO: Update this to work with setStorageData function
export const setLocalStorageData = (key, value) => {
	if (!value) {
		return;
	}
	localStorage.setItem(key, JSON.stringify(value));
};

// TODO: Update this to work with getStorageData
export const getLocalStorageData = (key, isPop) => {
	const storageData = JSON.parse(localStorage.getItem(key));
	if (isPop) {
		localStorage.removeItem(key);
	}
	return storageData;
};
